<template>
  <section>
    <!-- Componentes externos -->
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Comisión Viajes
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="orange"
                dark
                @click.native.stop="actualizarComisionViaje()"
                slot="activator"
                ><v-icon dark>history</v-icon>Actualizar registros</v-btn
              >
              <span>Agregar Comision viaje</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.item }}</td>
            <td class="text-xs-center">{{ items.item.nro_doc }}</td>

            <td class="nowrap text-xs-center">
              <!-- <v-tooltip bottom>
                <v-btn
                  color="green"
                  icon
                  slot="activator"
                  :to="`/comision-viaje/detalle-consulta/${items.item.nro_doc}`"
                >
                  <v-icon>flight</v-icon>
                </v-btn>
                <span>Ver viajes</span>
              </v-tooltip> -->
              <v-tooltip bottom>
                <v-btn
                  color="blue"
                  icon
                  slot="activator"
                  :to="`/comision-viaje/detalle/${items.item.id_persona}`"
                >
                  <v-icon>menu</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos

export default {
	// Importación de métodos y funciones de un archivo mixin
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: 'vListaPersonals',
			graphql: true,
      filters:true,
			// Cabecera de la tabla
			headers: [
        { text: 'Nombres', value: 'nombre', align: 'center' },
        { text: 'Ítem', value: 'item', align: 'center' },
        { text: 'CI', value: 'nro_doc', align: 'center' },

        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
        id_persona
        id_estado
        nro_doc
        nro_complemento
        item
        nombre
        unidad
        fecha_ingreso
        cargo
        id_cargo
        id_puesto
        id_item
        id_unidad
        id_movilidad
        estado
        es_autoridad
      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
			filters: [
        {
          field: 'nombre',
          label: 'Nombres',
          type: 'text', // Tipo de input en el filtro
          typeG: 'String' // Tipo definido en Graphql
        },
        {
          field: 'item',
          label: 'Ítem',
          type: 'text', // Tipo de input en el filtro
          typeG: 'String' // Tipo definido en Graphql
        },
         {
          field: 'nro_doc',
          label: 'CI',
          type: 'text', // Tipo de input en el filtro
          typeG: 'String' // Tipo definido en Graphql
        }
      ]
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }
   this.onFilter()
    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
		async actualizarComisionViaje (item) {
      try {
        let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"SELECT control.fn_registra_comision_viaje_cron()"){
                  respuesta
                }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_registra_comision_viaje_cron;
          respuesta = respuesta.split("|");
          let correcto = respuesta[0];
          if(correcto != "0"){
            this.$message.info(correcto)
          }else{
            this.$message.error(respuesta[1])
          }
      } catch (error) {
        console.log(error)
      }
		}
	},
	// Definición de componentes importados
	components: {
		CrudTable,
	}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/comision_viaje/ListadoFuncionarios.vue